module.exports = __webpack_public_path__ + "static/media/header-sprite.a576285c.svg";